module.exports = __webpack_public_path__ + "static/images/hero.2ecdf807c4cd9b504a0638bb40b64b9e.jpg";